// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lMN1","type":"styles_type__1tjCf","choices":"styles_choices__2PJlV"};